import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import PortModel from "../models/PortModel";

export interface SearchParam {
    searchText: string
}

export interface DeletePortParam {
    id: number
}

const PortSelectorApi = {
    GetAll() {
        return Api.get<null, BaseResponse<PortModel[]>>("/api/port/GetAll", null);
    },
    Save(param: PortModel) {
        return Api.post<PortModel, BaseResponse<string>>("/api/port/Save", param);
    },
    Search(param: SearchParam) {
        return Api.get<SearchParam, BaseResponse<PortModel[]>>("/api/port/GetAll", param);
    },
    Delete(param: DeletePortParam) {
        return Api.post<DeletePortParam, BaseResponse<string>>("/api/port/Delete", param);
    },
};
export default PortSelectorApi;